// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ji7Fn9agXkkw0a {
  display: flex;
  position: relative;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 6px 6px 6px 16px;
  transition: background-color ease-in 250ms, padding ease-in 250ms;
  border-bottom: 1px solid var(--ds-border, #091e4224);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 22px;
}
.Ji7Fn9agXkkw0a.Qh9dP3FUJwUq84 {
  background: var(--ds-background-warning, #fff7d6);
}
.Ji7Fn9agXkkw0a.tB8fyyjAnEkjql {
  background: var(--ds-background-information, #e9f2ff);
}
.Ji7Fn9agXkkw0a.K9Z4dOZpDDOSbY {
  background: var(--ds-background-discovery, #f3f0ff);
}
.Ji7Fn9agXkkw0a.YmJ9TlanqVsS_E {
  background-color: var(--ds-background-neutral-bold, #44546f);
}
.Ji7Fn9agXkkw0a.YmJ9TlanqVsS_E,
.Ji7Fn9agXkkw0a.YmJ9TlanqVsS_E * {
  color: var(--ds-text-inverse, #ffffff);
}
.Ji7Fn9agXkkw0a.r6wPTZpCPCh7jg {
  padding-right: 46px;
}
.Ji7Fn9agXkkw0a .kzHQfcaW3sfjAp {
  position: absolute;
  top: 50%;
  right: 6px;
  min-width: 34px;
  margin: -16px 0 0;
  padding: 0;
}
.Ji7Fn9agXkkw0a .kzHQfcaW3sfjAp .iFqksdYqFbgWYx {
  margin-right: 0;
}
@media print {
  .Ji7Fn9agXkkw0a {
    display: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerBanner": `Ji7Fn9agXkkw0a`,
	"warning": `Qh9dP3FUJwUq84`,
	"info": `tB8fyyjAnEkjql`,
	"discovery": `K9Z4dOZpDDOSbY`,
	"neutralBold": `YmJ9TlanqVsS_E`,
	"hasCloseButton": `r6wPTZpCPCh7jg`,
	"closeButton": `kzHQfcaW3sfjAp`,
	"closeIcon": `iFqksdYqFbgWYx`
};
export default ___CSS_LOADER_EXPORT___;
